import { type ReactNode } from 'react';
import clsx from 'clsx';

import styles from '../TextInput.module.css';

export function InnerInputContainer({
  children,
  activeClass,
  errorClass,
  disabledClass,
}: {
  children: ReactNode;
  activeClass: string | undefined;
  errorClass: string | undefined;
  disabledClass: string | undefined;
}) {
  return (
    <div
      className={clsx(
        styles['input-inner'],
        activeClass,
        errorClass,
        disabledClass
      )}
    >
      {children}
    </div>
  );
}
